export default __webpack_public_path__ + "static/media/arrow-right.a7934f05.svg";